import { MarketDataPercentages } from '@client/graphql/__generated__/types';
import { isNil } from 'lodash';
import { ReactNode } from 'react';
import { useIsMobile } from '~/common/hooks/useIsMobile';
import { getMarketDataDisplay } from '../common.utils';
import { CommonKeyTermProps } from './useCommonKeyTermLogic';

export type SellerConcessionProps = CommonKeyTermProps & {
  marketDataPercentages?: MarketDataPercentages;
};

export const useSellerConcessionLogic = (props: SellerConcessionProps) => {
  const isMobile = useIsMobile();
  const { marketDataPercentages, range } = props;

  const getMainValueLabel = (): ReactNode => {
    return getMarketDataDisplay(
      marketDataPercentages,
      isMobile ? 'have conc.' : 'have concessions'
    );
  };

  const getDotColorValue = (value?: number | null): string => {
    if (isNil(value) || isNil(range) || range.length < 2) return 'gray.500';

    return value <= range[1] ? 'green.500' : 'red.500';
  };

  return {
    // !NOTE: backend now returns recommendation as 0 for seller concessions
    // we're overriding here to prevent regression on the previously created
    // offer scorecard
    getPlaceholderValue: () => 0,
    getDotColorValue,
    getMainValueLabel,
  };
};
